import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import ddcLogo from '../../images/nycddc.png';
import { fetchProject, fetchProgressReports } from '../../actions/project_actions'
import { SECTIONS, NAMES } from '../../utils/progressReport';

class ProgressReport extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   reportId: PropTypes.string.isRequired,
  //   info: PropTypes.object.isRequired,
  //   progressReports: PropTypes.array.isRequired,
  //   divisionName: PropTypes.string.isRequired,
  //   fetchProject: PropTypes.func.isRequired,
  //   fetchProgressReports: PropTypes.func.isRequired,
  // }

  UNSAFE_componentWillMount () {
    const { projectId, progressReports } = this.props;
    if (progressReports.length === 0) {
      this.props.fetchProject(projectId);
      this.props.fetchProgressReports(projectId);
    }
  }

  renderReport (progressReport) {
    if (!progressReport) return null;

    return SECTIONS.map((section, index) =>
      <div key={section} className="break-avoid">
        <h4>{ NAMES[index] }</h4>
        <div dangerouslySetInnerHTML={ {__html: progressReport[section]} } />
      </div>
    )
  }

  render () {
    const { reportId, progressReports } = this.props;
    const progressReport = _.find(progressReports, {id: parseInt(reportId, 10)});
    return (
      <div className="progress-report">
        <h1>
          <img src={ddcLogo} alt="NYC DDC logo" />
          <span>{progressReport && progressReport.title}</span>
        </h1>

        { progressReport
          ? <div>
              <div dangerouslySetInnerHTML={ {__html: progressReport.infoText} } />
              <div dangerouslySetInnerHTML={ {__html: progressReport.scheduleText} } />
              <div dangerouslySetInnerHTML={ {__html: progressReport.contractText} } />
            </div>
          : null }

        <div className="section">
          <h2>CONSTRUCTION ACTIVITIES</h2>
          <div className="info">
            {this.renderReport(progressReport)}
          </div>
        </div>
      </div>
    );
  }
}

ProgressReport.propTypes = {
  projectId: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
  info: PropTypes.object.isRequired,
  progressReports: PropTypes.array.isRequired,
  divisionName: PropTypes.string.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchProgressReports: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    reportId: ownProps.reportId,
    info: state.projectsStore.info,
    progressReports: state.projectsStore.progressReports,
    divisionName: state.projectsStore.divisionName,
  };
}

export default connect(mapStateToProps, { fetchProject, fetchProgressReports })(ProgressReport);